import React, { useEffect, useState } from "react";
import { Box, Paper, Grid, List, ListItem, ListItemText, Link } from "@mui/material";
import MKTypography from "../components/MKTypography";
import { Link as RouterLink } from "react-router-dom";
import CustomCalendar from "../components/CustomCalendar";
import { useAppSelector } from "../store/hooks";
import { selectUser } from "../store/userSlice";
import API_BASE_URL from "../apiConfig";

function DashboardPage() {
  const user = useAppSelector(selectUser);
  const [clubs, setClubs] = useState([]);
  const [events, setEvents] = useState([]);
  const [news, setNews] = useState([]);

  useEffect(() => {
    if (!user) return;
    fetch(`${API_BASE_URL}/api/users/${user.id}/clubs`)
      .then(res => res.json())
      .then(data => Array.isArray(data) ? setClubs(data) : setClubs([]));
    fetch(`${API_BASE_URL}/api/users/${user.id}/followed-events`)
      .then(res => res.json())
      .then(data => Array.isArray(data) ? setEvents(data) : setEvents([]));
    fetch(`${API_BASE_URL}/api/users/${user.id}/followed-news`)
      .then(res => res.json())
      .then(data => Array.isArray(data) ? setNews(data) : setNews([]));
  }, [user]);

  return (
    <Box sx={{ p: 3 }}>
      <MKTypography variant="h3" fontWeight="bold" mb={3} sx={{ color: '#e91e63' }}>
        Dashboard
      </MKTypography>
      <Grid container spacing={3}>
        {/* Main content: Calendar and News */}
        <Grid item xs={12} md={9}>
          <Paper sx={{ p: 3, mb: 3 }}>
            <MKTypography variant="h4" mb={2} sx={{ color: '#e91e63' }}>Upcoming Events Calendar</MKTypography>
            <CustomCalendar events={events} />
          </Paper>
          <Paper sx={{ p: 3 }}>
            <MKTypography variant="h4" mb={2} sx={{ color: '#e91e63' }}>Recent News</MKTypography>
            <List>
              {news.length === 0 && <ListItem><ListItemText primary="No news yet." /></ListItem>}
              {news.map(item => {
                return (
                  <ListItem key={item.id}>
                    <ListItemText
                      primary={item.title} 
                      secondary={
                        <Box>
                          <MKTypography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                            {item.content}
                          </MKTypography>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            {item.club_handle ? (
                              <Link
                                component={RouterLink}
                                to={`/clubs/${item.club_handle}`}
                                sx={{
                                  color: "#e91e63",
                                  textDecoration: "none",
                                  fontWeight: 500,
                                  fontSize: "0.875rem",
                                  "&:hover": {
                                    textDecoration: "underline"
                                  }
                                }}
                              >
                                {item.club_name || "Unknown Club"}
                              </Link>
                            ) : (
                              <MKTypography variant="body2" color="text.secondary" sx={{ fontSize: "0.875rem", fontWeight: 500 }}>
                                {item.club_name || "Unknown Club"}
                              </MKTypography>
                            )}
                            <MKTypography variant="caption" color="text.secondary" sx={{ fontSize: "0.75rem" }}>
                              • {new Date(item.posted_at).toLocaleDateString()}
                            </MKTypography>
                          </Box>
                        </Box>
                      }
                    />
                  </ListItem>
                );
              })}
            </List>
          </Paper>
        </Grid>
        {/* Sidebar: My Clubs */}
        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <MKTypography variant="h4" mb={2} sx={{ color: '#e91e63' }}>My Clubs</MKTypography>
            <List>
              {clubs.length === 0 && <ListItem><ListItemText primary="No clubs followed yet." /></ListItem>}
              {clubs.map(club => (
                <ListItem key={club.id}>
                  <ListItemText 
                    primary={
                      <Link
                        component={RouterLink}
                        to={`/clubs/${club.handle}`}
                        sx={{
                          color: "#e91e63",
                          textDecoration: "none",
                          fontWeight: 500,
                          "&:hover": {
                            textDecoration: "underline"
                          }
                        }}
                      >
                        {club.name}
                      </Link>
                    } 
                    secondary={club.description} 
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default DashboardPage;